const hostname = typeof window !== "undefined" ? window.location.hostname : ""

export const isLocalHost =
  ["localhost", "127.0.0.1", "::1", "0.0.0.0"].includes(hostname) ||
  hostname.startsWith("192.168.") ||
  hostname.startsWith("10.")

export interface AppCheckStatusDetail {
  status: "error"
  message: string
  code?: string
}

export const APP_CHECK_STATUS_EVENT = "winfacil-app-check-status"

export function dispatchAppCheckStatus(detail: AppCheckStatusDetail) {
  if (typeof window === "undefined") {
    return
  }

  window.dispatchEvent(new CustomEvent(APP_CHECK_STATUS_EVENT, { detail }))
}
